import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { EndpointConfig, SiteConfig } from 'top-context';
import { SettingsState } from './settings.type';

export const initialState: SettingsState = {
  appName: '',
  endpointConfig: {} as EndpointConfig,
  siteConfig: {} as SiteConfig,
  // all modules are defaulted to be active
  activeModules: {
    claims: true,
  },
};

const settingsSlice = createSlice({
  name: 'settings',
  initialState,
  reducers: {
    setSettings: (state, { payload }: PayloadAction<SettingsState>) => {
      state.appName = payload.appName;
      state.endpointConfig = payload.endpointConfig;
      state.siteConfig = payload.siteConfig;
      state.activeModules = payload.activeModules;
    },
  },
});

export const settingsReducer = settingsSlice.reducer;
export const settingsActions = settingsSlice.actions;
